import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { NoAuthGuard } from './guards/no-auth.guard';

export const routes: Routes = [
  // Zona pública
  {
    path: '',
    loadComponent: () => import('./layouts/public-layout/public-layout.component').then(m => m.PublicLayoutComponent),
    children: [
      {
        path: 'login',
        loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
        canActivate: [NoAuthGuard]
      },
      {
        path: 'auth-internal',
        loadComponent: () => import('./pages/auth-internal/auth-internal.component').then(m => m.AuthInternalComponent),
        canActivate: [NoAuthGuard]
      },
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full'
      }
    ]
  },
  // Zona privada
  {
    path: 'dashboard',
    loadComponent: () => import('./layouts/dashboard-layout/dashboard-layout.component').then(m => m.DashboardLayoutComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent)
      },
      {
        path: 'user-list',
        loadComponent: () => import('./pages/user-list/user-list.component').then(m => m.UserListComponent),
        canActivate: [AuthGuard],
        data: { types: ['employee', 'god'] }
      },
      {
        path: 'user/new',
        loadComponent: () => import('./pages/user-form/user-form.component').then(m => m.UserFormComponent),
        canActivate: [AuthGuard],
        data: { types: ['employee', 'god'] }
      },
      {
        path: 'user/edit/:id',
        loadComponent: () => import('./pages/user-form/user-form.component').then(m => m.UserFormComponent),
        canActivate: [AuthGuard],
        data: { types: ['employee', 'god'] }
      },
      {
        path: 'user/:id',
        loadComponent: () => import('./pages/user/user.component').then(m => m.UserComponent),
        canActivate: [AuthGuard],
        data: { types: ['employee', 'god'] }
      },
      {
        path: 'companies',
        loadComponent: () => import('./pages/company-list/company-list.component').then(m => m.CompanyListComponent),
        canActivate: [AuthGuard],
        data: { types: ['god'] }
      },
      {
        path: 'companies/new',
        loadComponent: () => import('./pages/company-form/company-form.component').then(m => m.CompanyFormComponent),
        canActivate: [AuthGuard],
        data: { types: ['god'] }
      },
      {
        path: 'companies/edit/:id',
        loadComponent: () => import('./pages/company-form/company-form.component').then(m => m.CompanyFormComponent),
        canActivate: [AuthGuard],
        data: { types: ['god'] }
      },
      {
        path: 'companies/view/:id',
        loadComponent: () => import('./pages/company-view/company-view.component').then(m => m.CompanyViewComponent),
        canActivate: [AuthGuard],
        data: { types: ['god'] }
      },
      {
        path: 'settings',
        loadComponent: () => import('./pages/settings/settings.component').then(m => m.SettingsComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfileComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'schedule-list',
        loadComponent: () => import('./pages/schedule-list/schedule-list.component').then(m => m.ScheduleListComponent),
        canActivate: [AuthGuard],
        data: { types: ['employee', 'god'] }
      },
      {
        path: 'schedule-day-config',
        loadComponent: () => import('./pages/schedule-day-config/schedule-day-config.component').then(m => m.ScheduleDayConfigComponent),
        canActivate: [AuthGuard],
        data: { types: ['employee', 'god'] }
      },
      {
        path: 'schedule-calendar',
        loadComponent: () => import('./pages/schedule-calendar/schedule-calendar.component').then(m => m.ScheduleCalendarComponent),
        canActivate: [AuthGuard],
        data: { types: ['employee', 'god', 'client'] }
      },
      {
        path: 'class-detail/:classId/:date',
        loadComponent: () => import('./pages/class-detail/class-detail.component').then(m => m.ClassDetailComponent),
        canActivate: [AuthGuard],
        data: { types: ['employee', 'god', 'client'] }
      },
      {
        path: 'my-reservations',
        loadComponent: () => import('./pages/my-reservations/my-reservations.component').then(m => m.MyReservationsComponent),
        canActivate: [AuthGuard],
        data: { types: ['client', 'employee'] }
      },
      {
        path: 'class-reservations',
        loadComponent: () => import('./pages/class-reservations/class-reservations.component').then(m => m.ClassReservationsComponent),
        canActivate: [AuthGuard],
        data: { types: ['employee', 'god'] }
      },
      {
        // Detalle de la clase dentro de Lista de Reservas: misma pagina pero
        // en otra ruta para que el back-arrow del dashboard layout sepa que
        // estamos en una sub-pantalla y muestre flecha atras.
        path: 'class-reservations/:classId/:date',
        loadComponent: () => import('./pages/class-reservations/class-reservations.component').then(m => m.ClassReservationsComponent),
        canActivate: [AuthGuard],
        data: { types: ['employee', 'god'] }
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      }
    ]
  },
  // Ruta directa para mis reservas (accesible para todos los usuarios autenticados)
  {
    path: 'my-reservations',
    loadComponent: () => import('./pages/my-reservations/my-reservations.component').then(m => m.MyReservationsComponent),
    canActivate: [AuthGuard],
    data: { types: ['client', 'employee'] }
  }
];
